//IMPORT VALIDATION
export const importModalValidation = {
    ERROR_IMPORT : 'Errors while importing given data... Check logs!!!',
    FAILED_IMPORT : 'Failed to import given data...',
    SUCCESS_IMPORT : 'File Uploaded Successfully!!!'

}

export const importModalText = {
    IMPORT_FILE : "Import File",
    FORMAT_MESSAGE : "Import Data Using Excel Sheet(Format- xls,xlsx).",
    UPLOAD_FILE : "Upload File",
    DOWNLOAD_MESSAGE : "Download Excel Template from",
    HERE : "Here",
    LOADING : "Loading...",
    CANCEL : "Cancel",
    UPLOAD : "Upload",
    IMPORT : "Import",
    DETAIL : "Detail",
    RECORDS : "Records",
    SUCCESS_UPLOAD : "Success Upload",
    FAILED_UPLOAD : "Failed Upload",
    ROW_NUMBER : "Row Number",
    ERROR : "Error",
    CHECK : "Check",
    LOGS : "Logs",
    IMPORT_FILE_LOG : "Import File Log"
}
